export const mediaExtensions = ['JPEG', 'PNG', 'JPG', 'MP4', 'WEBP'];
export const audioExtensions = ['MP3', 'OGG', 'WAV', 'AMR', 'OPUS'];
export const videoExtensions = ['mp4', 'webp'];
export const imagesExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
export const textExtensions = ['DOC', 'DOCX', 'PDF', 'TXT', 'XLS', 'XLSX'];

export const IN = 'in';
export const OUT = 'out';

export const PENDING = 'pending';
export const SENT = 'sent';
export const DELIVERED = 'delivered';
export const READ = 'read';
export const DELETED = 'deleted';
export const ERROR = 'error';
